import { GetterTree } from 'vuex'
import { IUiNotificationsState } from './state'

const getters: GetterTree<IUiNotificationsState, IUiNotificationsState> = {
  notifications: ({ notifications }) => notifications,
}

export default getters
